/**
 * Routen-Gate auf `allowed_applications` (#504).
 *
 * Bis hierher galt für alles ein einziges Gate: `webos`. Seit die shell-freien
 * Routen cdb-pdb ablösen sollen, hängen sie an `pdb` — und zwar allein, sonst
 * käme ein reiner PDB-Nutzer nie dort an.
 *
 * Wer die verlangte Anwendung nicht hat, landet nicht auf dem Login: er ist ja
 * angemeldet, und der Login schickte ihn umgehend zurück — dieselbe Schleife,
 * die cdb-pdb mit einer eigenen Access-Denied-Seite gelöst hat. Stattdessen
 * führt der Weg dorthin, wo der Nutzer etwas darf, und nur wenn es das nicht
 * gibt, auf die Login-Seite mit ihrem Freischaltungs-Hinweis.
 */
import { Navigate, Outlet } from 'react-router'
import { RouteLoading } from './RouteLoading'
import {
  useAllowedApplications,
  DESKTOP_APPLICATION,
  STANDALONE_APPLICATION,
  type ApplicationId,
} from '@/hooks/useAllowedApplications'

export function RequireApplication({ app }: { app: ApplicationId }) {
  const { apps, isLoading, has } = useAllowedApplications()

  // Zweites von zwei Gates auf diesem Weg; die Begruendung steht in
  // `RouteLoading`.
  if (isLoading) return <RouteLoading />

  if (has(app)) return <Outlet />

  // Ein Ausweichziel, an dem der Nutzer tatsächlich etwas darf — sonst wirkt
  // die Abweisung wie ein Fehler, obwohl nur diese eine Route gesperrt ist.
  if (app !== DESKTOP_APPLICATION && apps?.includes(DESKTOP_APPLICATION)) {
    return <Navigate to="/desktop" replace />
  }
  if (app !== STANDALONE_APPLICATION && apps?.includes(STANDALONE_APPLICATION)) {
    return <Navigate to="/chat" replace />
  }

  return <Navigate to="/" replace />
}
